export default "__VITE_ASSET__DqvC9GGU__"